import React, {forwardRef, useEffect, useState} from 'react';
import Modal from "react-modal";
import OtpInput from 'react-otp-input';
import {useCountdownTime} from "../../hooks/useCountdownTime";
import Contract from "../Contract";
import {approvalContract, reassignOtp, rejectContract, verifyOtp} from "../../services";
import Spinner from "../Spinner";
import {useOTP} from "../../hooks/useOTP";

const Input = forwardRef((props, ref) => {
    const [isFocus, setIsFocus] = useState(false);
    const handleFocus = (e) => {
        props.onFocus(e);
        setIsFocus(true);
    }
    return (
        <div className="flex relative items-center justify-center">
            <input ref={ref} {...props} onFocus={handleFocus} onBlur={() => setIsFocus(false)}
                   className="bg-transparent text-lg outline-0 !w-6 h-6 border-b border-b-gray-500" />
            {!isFocus && !props.value && <div className="rounded-full bg-gray-500 w-1 h-1 absolute"/>}
        </div>
    )
})
const DialogOTP = ({open, onClose, openAlert, token, data}) => {
    const [isOk, setOk] = useState(false);
    const [otp, setOtp] = useState('');
    const [times, start, restart] = useCountdownTime();
    const [transactionId, setTransactionId] = useState();
    const [phoneNumber, setPhoneNumber] = useState();
    const [error, setError] = useState("");
    const [loading, setLoading] = useState(false);
    const [otpTurn, setOtpTurn] = useState(0);
    const [numberError, setNumberError] = useState(0);
    const [height, setHeight] = useState(0);
    const [autoFocus,setAutoFocus] = useState(false)
    const [closeOtp] = useOTP((otpSms)=>{
        if(otpSms){
            onChangeOtp(otpSms);
        }else {
            setAutoFocus(true);
        }
    })
    useEffect(() => {
        setInterval(() => {
            const height = window.innerHeight;
            setHeight(height)
        }, 100);
    }, []);
    const handleOtp = () => {
        setOk(true);
        approvalContract(token).then(r => {
            if (r && !r.errorCode) {
                setNumberError(0);
                setTransactionId(r.transactionId)
                setPhoneNumber(r.last4DigitPhoneNumber)
            }
        })
        start()
    }
    const handleReject = () => {
        onClose()
        rejectContract(token).then();
    }
    const onChangeOtp = (value) => {
        setError("")
        setOtp(value);
        if (value.length === 6) {
            setLoading(true)
            verifyOtp(transactionId, value, token).then(r => {
                setLoading(false)
                if (r?.errorCode) {
                    if (numberError === 2) {
                        openAlert({message: r.message, onClose: () => openAlert()})
                        onClose();
                    }
                    setNumberError(numberError + 1)
                    setError(r.message);
                } else {
                    onClose()
                }
            })
        }
    }
    const resendOtp = () => {
        setError("");
        reassignOtp(transactionId, token).then((r) => {
            if (r.errorCode) {
                setError(r.message)
            } else {
                setNumberError(0);
                setOtpTurn(otpTurn + 1);
                setTransactionId(r.transactionId)
                restart()
            }
        })
    }
    return (
        <Modal
            isOpen={open}
            className="w-full h-full absolute flex flex-col overflow-hidden top-1/2 left-1/2 -translate-y-2/4 -translate-x-2/4"
            contentLabel="Modal"
            style={{overlay:{height}}}
            overlayClassName="w-full fixed top-0 z-[10000]"
        >
            <div className="w-full flex-1 flex flex-col bg-white mt-24 relative">
                {loading && <div
                    className="absolute z-50 bg-white/80 top-0 right-0 left-0 bottom-0 flex items-center justify-center">
                    <Spinner/>
                </div>}
                <div className="p-3 shadow  bg-white flex items-center">
                    {/*<button onClick={onClose}><CloseIcon/></button>*/}
                    <h4 className="flex-1 text-center font-bold">
                        {isOk ? "Nhập OTP" : "Giấy đề nghị nâng cấp gói EKYC"}</h4>
                </div>
                {!isOk && (<div className="flex-1"><Contract height={height} data={data}/></div>)}
                {isOk && (<div className="flex-1 p-8 flex flex-col items-center">
                    <div className="font-bold text-center mb-6">Nhập mã xác nhận đã được gửi qua số điện thoại
                        ***{phoneNumber}
                    </div>
                    <OtpInput
                        value={otp}
                        onChange={onChangeOtp}
                        numInputs={6}
                        shouldAutoFocus={autoFocus}
                        renderSeparator={<div className="p-2"/>}
                        renderInput={(props) => <Input  {...props} pattern="\d*" type="number"  inputMode="decimal" />}
                    />
                    <div className="text-red-600 text-center mt-4">{error}</div>
                    {otpTurn < 3 &&
                        <button className="text-[#01AD53] mt-6" onClick={resendOtp}>Gửi lại mã OTP</button>}
                    {times > 0 && <div className="text-sm text-gray-500 mt-1">OTP hết hiệu lực sau {times} giây</div>}
                    {times === 0 && <div className="text-sm text-gray-500 mt-1">OTP hết hiệu lực</div>}
                </div>)}
                {!isOk && (
                    <div className="shadow-[rgba(0,0,0,0.2)_0px_5px_4px_8px] bg-white ">
                        <div className="flex-1">
                            <button onClick={handleReject}
                                    className="border-r font-bold p-3 w-1/2 border-t-slate-300">
                                Từ chối
                            </button>
                            <button className=" p-3 text-[#01AD53] w-1/2 font-bold border-t-slate-300 flex-1"
                                    onClick={handleOtp}>Đồng ý
                            </button>
                        </div>
                    </div>
                )}
            </div>
        </Modal>
    )
}

export default DialogOTP